import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Attachment } from 'src/app/models/attachment.interface';

@Component({
  selector: 'app-meeting-record-attachments-tab',
  templateUrl: './meeting-record-attachments-tab.component.html',
  styleUrls: ['./meeting-record-attachments-tab.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, MatButtonModule, MatIconModule],
})
export class MeetingRecordAttachmentsTabComponent {
  attachments = input.required<Attachment[]>();

  can_manage = input.required<boolean>();

  is_create = input.required<boolean>();

  download_attachment = output<Attachment>();

  delete_attachment = output<Attachment>();

  protected readonly attachment_rows = computed(() =>
    this.attachments().map(attachment => ({
      attachment,
      is_image: isAttachmentImage(attachment.file_name),
    }))
  );
}

const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg']);

function isAttachmentImage(file_name: string | null | undefined): boolean {
  const extension = (file_name?.split('.').pop() ?? '').toLowerCase();

  return IMAGE_EXTENSIONS.has(extension);
}
